import { JournDayPage } from '_/features/journ/ui/pages/journ-day-page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/journ/')({
	staticData: { title: 'journ_title' },
	component: JournDayPage,
})
